export default "__VITE_ASSET__qNx406xw__"